import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/tipoManoObra';
import Tipos from './tipoManoObra';


const ms2p = (state) => {
  return {
    ...state.proyecto_tipo_mano_obra,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Tipos);
